var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 35,
    viewBox: "0 0 15 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4069 15.4596L4.93148 1.58669C4.27656 0.627829 3.26878 0.66045 2.68387 1.65945L1.26166 4.0618C0.670119 5.06101 0.721363 6.64413 1.37595 7.59258L8.09236 17.426L2.02594 27.6733C1.4344 28.6725 1.48564 30.2556 2.14023 31.204L3.70887 33.5304C4.36379 34.4893 5.37156 34.4567 5.95647 33.4577L14.5149 19.001C15.1131 18.0016 15.0618 16.4185 14.4069 15.4596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3e4f58e56b3d55d85d4ce3d1098fa41a.svg";
export { ForwardRef as ReactComponent };